export const AUDIT_LOGS_ROOT_URL = '/audit_logs';
